import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { faEnvelope, faPassport, faPhoneVolume } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export const AppFooter = () => {

    const navigateTo = useNavigate();

    const { pathName } = useLocation();
    
    useEffect(() => {
        window.scrollTo(0,0)
    }, [pathName]);

    return (
        <footer>
            <div className="lg-footer-section">
                <div className="contact-caption">
                    Do you have questions or want more information? Contact us now
                </div>
                <div className="cont-elem">
                    <div className="cont-circle">
                        <FontAwesomeIcon icon={faPhoneVolume} color="#079883" />
                    </div>
                    <div className="contact-caption">+23761111114</div>
                </div>

                <div className="cont-elem">
                    <div className="cont-circle">
                        <FontAwesomeIcon icon={faEnvelope} color="#079883" />
                    </div>
                    <div className="contact-caption">uest-travel@mail.com</div>
                </div>

                <div className="cont-elem">
                    <div className="cont-circle">
                        <FontAwesomeIcon icon={faFacebookF} color="#079883" />
                    </div>
                    <a href="https://m.facebook.com/uest.coltd/" className="contact-caption">Follow us</a>
                </div>
                
            </div>
            <div className="sm-footer-section">
                <div className="footer-caption">Explore Link</div>
                <div className="lnk-unit" onClick={() => navigateTo("/about")}>
                    <FontAwesomeIcon icon={faPassport} color="#079883" />
                    <span className="lnk-txt">About us</span>
                </div>
                <div className="lnk-unit" onClick={() => navigateTo("/services")}>
                    <FontAwesomeIcon icon={faPassport} color="#079883" />
                    <span className="lnk-txt">Services</span>
                </div>
                <div className="lnk-unit" onClick={() => navigateTo("/visa-programs")}>
                    <FontAwesomeIcon icon={faPassport} color="#079883" />
                    <span className="lnk-txt">Visa Programs</span>
                </div>
                <div className="lnk-unit" onClick={() => navigateTo("/policy")}>
                    <FontAwesomeIcon icon={faPassport} color="#079883" />
                    <span className="lnk-txt">Privacy policy</span>
                </div>
                <div className="lnk-unit" onClick={() => navigateTo("/terms")}>
                    <FontAwesomeIcon icon={faPassport} color="#079883" />
                    <span className="lnk-txt">Terms and conditions</span>
                </div>
            </div>
            <div className="sm-footer-section">
                <div className="footer-caption">Services</div>
                <div className="lnk-unit">
                    <FontAwesomeIcon icon={faPassport} color="#079883" />
                    <span className="lnk-txt">Translation services </span>
                </div>
                <div className="lnk-unit">
                    <FontAwesomeIcon icon={faPassport} color="#079883" />
                    <span className="lnk-txt">Reservation and sales of flight Tickets</span>
                </div>
                <div className="lnk-unit">
                    <FontAwesomeIcon icon={faPassport} color="#079883" />
                    <span className="lnk-txt">Sales and recharge of VISA cards</span>
                </div>
                <div className="lnk-unit">
                    <FontAwesomeIcon icon={faPassport} color="#079883" />
                    <span className="lnk-txt">Housing services abroad</span>
                </div>
                <div className="lnk-unit">
                    <FontAwesomeIcon icon={faPassport} color="#079883" />
                    <span className="lnk-txt">Airport assistance and pick-up services</span>
                </div>
            </div>
        </footer>
    );
}